<template>
  <v-dialog
    @keydown.esc="dateModal=false"
    ref="dialogDates"
    v-model="dateModal"
    :return-value.sync="dates"
    width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateRangeText"
        :label="$t('components.dateRangeInput.dateRange')"
        readonly
        outlined
        dense
        v-bind="attrs"
        v-on="on"
        class="calendarTextField"
      >
        <v-icon slot="append" color="#01D28E">
          mdi-calendar
        </v-icon>
      </v-text-field>
    </template>
    <v-date-picker
      v-if="isRange"
      v-model="dates"
      scrollable
      ref="picker"
      color="primary"
      :allowed-dates="allowedDates"
      :first-day-of-week="1"
      @input="orderDateRange"
      range
      reactive
      no-title
      class="pt-4"
      :locale="locale">
      <v-spacer></v-spacer>
      <v-btn
        text
        color="primary"
        @click="dateModal = false"
        class="dateButton"
      >
        {{ $t('components.dateRangeInput.cancel') }}
      </v-btn>
      <v-btn
        text
        color="primary"
        @click="confirmDates"
        class="dateButton"
      >
        {{ $t('components.dateRangeInput.ok') }}
      </v-btn>
    </v-date-picker>
    <v-date-picker
      v-else
      v-model="month"
      scrollable
      ref="picker"
      color="primary"
      :allowed-dates="allowedDates"
      :first-day-of-week="1"
      @input="orderDateRange"
      type="month"
      reactive
      no-title
      class="pt-4"
      :locale="locale">
      <v-spacer></v-spacer>
      <v-btn
        text
        color="primary"
        @click="dateModal = false"
        class="dateButton"
      >
        {{ $t('components.dateRangeInput.cancel') }}
      </v-btn>
      <v-btn
        text
        color="primary"
        @click="confirmDates"
        class="dateButton"
      >
        {{ $t('components.dateRangeInput.ok') }}
      </v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
import getLocale from '@/lang/locale'

export default {
  name: 'DateRangeInput',
  props: {
    selectedDates: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'date'
    }
  },
  data () {
    return {
      dateModal: false,
      dates: [],
      month: new Date().toISOString()
    }
  },
  watch: {
    selectedDates: function (val) {
      if (this.isRange) {
        this.dates = [ ...val ]
      }
    },
    month: function (val) {
      const startDate = this.$moment(`${val}-01`).startOf('month').format('YYYY-MM-DD')
      const endDate = this.$moment(`${val}-01`).endOf('month').format('YYYY-MM-DD')
      this.dates = [startDate, endDate]
    }
  },
  computed: {
    dateRangeText () {
      return this.dates.join(' ~ ')
    },
    locale () {
      return getLocale(this.$i18n.locale)
    },
    isRange () {
      return this.type === 'date'
    }
  },
  methods: {
    confirmDates () {
      this.$refs.dialogDates.save(this.dates)
      this.$emit('update', this.dates)
    },
    allowedDates (val) {
      const nowDate = new Date()
      const evalDate = new Date(this.$moment(val).format('YYYY-MM-DDTHH:mm:ss.SSS'))

      return evalDate.getTime() <= nowDate.getTime()
    },
    orderDateRange () {
      this.dates.sort((a, b) => new Date(a) - new Date(b))
    }
  }
}
</script>

<style lang="scss">
  .calendarTextField {
    height: 34px;
    width: 240px;
    border-radius: 22px;

    & ::v-deep .v-label {
      top: auto;
    }
  }

  .dateButton {
    text-transform: none;
  }
</style>
